import angular from 'angular'
import templateUrl from './event-scheduling-employee-tsu-report.component.html'

export const EventsSchedulingEmployeeTsuReportComponent = {
    controller: EventsSchedulingEmployeeTsuReportController,
    templateUrl,
    controllerAs: "vm",
    bindings: {
        params: "<"
    }
}

function EventsSchedulingEmployeeTsuReportController($q, apexApiUrl, utilityService,
    scheduleEventService) {

    'ngInject'
    const vm = this;
    vm.$onInit = activate;
    vm.$onChanges = onChanges;
    vm.pageNumber = 1;
    vm.pageSize = 50;
    vm.loaded = false;
    vm.onChangeFilter = onChangeFilter;
    vm.filters = {}

    function activate() {
    }

    function loadScheduleEventEmployeeTsuReport() {
        const params = vm.params
        utilityService.showLoading();
        scheduleEventService.retrieveScheduleEventEmployeeTsuReport(params)
            .then(function (data) {
                vm.report = data.Report;
                vm.filteredReport = angular.copy(vm.report);
                vm.headerDates = data.HeaderDates;
                calculateTotals();
                return data;
            }).catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function onChanges(changes) {
        if (changes.params) {
            loadScheduleEventEmployeeTsuReport();
        }
    }

    function onChangeFilter() {

        vm.filteredReport = angular.copy(vm.report);
        vm.filteredReport = vm.filteredReport.filter(filterScheduleEvents);
        calculateTotals();
    }

    function filterScheduleEvents(event) {

        const ownerClinetName = event.OwnerName + " - " + event.ClientName;

        return (!vm.filters.OwnerClientName || utilityService.containsInvariant(ownerClinetName,
            vm.filters.OwnerClientName))
            && (!vm.filters.HostLocationName || utilityService.containsInvariant(event.HostLocationName,
                vm.filters.HostLocationName))
            && (!vm.filters.HostNumber || utilityService.containsInvariant(event.HostNumber,
                vm.filters.HostNumber))
            && (!vm.filters.EmployeeName ||
                utilityService.containsInvariant(event.EmployeeName, vm.filters.EmployeeName));
    }

    function calculateTotals() {
        vm.headerTotals = [];
        vm.headerDates.forEach(function (header, index) {

            const columnTotals = vm.filteredReport.reduce(function (columnTotals, row) {
                columnTotals.total += row.Dates[index].Count;
                return columnTotals;
            }, { total: 0 });
            vm.headerTotals.push({ index: index, Total: columnTotals.total });
        });

        vm.reportTotal = vm.filteredReport.reduce(function (totals, data) {
            totals.Totals += data.TotalTsuCount;
            return totals;
        }, { Totals: 0 });
    }

}
